import { useDesignMaxTheme } from "@/packages";
import { FONT } from "@/styles";
import { Box, Center, Flex, Text } from "@chakra-ui/react";
import { type RoomInfoProps } from "./roomInfo.type";

export const RoomInfo = ({ isPriceOff, name, discountRate, personOfCapacity, structure }: RoomInfoProps) => {
    const { COLORS, MEDIAS } = useDesignMaxTheme();
    const { isMobile } = MEDIAS();

    return (
        <Center flexDir="column" rowGap="16px" alignItems="flex-start">
            <Flex flexDir="column" rowGap="8px">
                <Text sx={{ ...FONT("pretendard", 20, 700) }}>{name}</Text>
                {isPriceOff && (
                    <Flex>
                        <Text
                            p="4px 8px"
                            border={discountRate !== 0 ? "none" : "1px solid"}
                            borderRadius="8px"
                            boxSizing="border-box"
                            fontSize="16px"
                            fontWeight="300"
                            fontFamily="Pretendard Variable"
                            color={discountRate !== 0 ? COLORS.white : COLORS.black}
                            bgColor={discountRate !== 0 ? COLORS.black : COLORS.white}
                        >
                            특가할인 {discountRate !== 0 ? discountRate : "없음"}
                            {discountRate ? "%" : ""}
                        </Text>
                    </Flex>
                )}
            </Flex>
            <Box
                sx={{
                    "& > p": {
                        ...FONT("pretendard", 16, 300),
                        overflow: "hidden",
                        w: isMobile ? "auto" : "100%",
                        maxW: "320px",
                        textOverflow: "ellipsis",
                        whiteSpace: isMobile ? "normal" : "nowrap",
                    },
                }}
            >
                <Text>
                    기준인원 {personOfCapacity.min}인 ~ 최대인원 {personOfCapacity.max}인
                </Text>
                <Text>{structure}</Text>
            </Box>
        </Center>
    );
};
